import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { PropertyTypeBreakdownContent } from 'src/v2/views/owner-reveal/insights/portfolio-summary/property-type-breakdown/content'

export const PropertyTypeBreakdown: FC = () => {
  return (
    <WidgetCard
      id="property-type-breakdown"
      title="Property Type Breakdown"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <PropertyTypeBreakdownContent />,
        },
      ]}
    />
  )
}
